import { render, staticRenderFns } from "./ChildList.vue?vue&type=template&id=9113270e&"
import script from "./ChildList.vue?vue&type=script&lang=js&"
export * from "./ChildList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports